module.exports = __webpack_public_path__ + "img/media_newspaper.f94af693.jpg";